import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueRouter from "vue-router";
import { routes } from "./router/routes";
import { index } from "./components/index";

// Router
Vue.use(VueRouter);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

// register the plugin on vue
import Toasted from "vue-toasted";
Vue.use(Toasted);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

import Notifications from "vue-notification";
Vue.use(Notifications);
Vue.use(VueSweetalert2);

import excel from "vue-excel-export";
Vue.use(excel);
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

const router = new VueRouter({
  routes,
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  mode: "hash",
});

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
  components: { App },
});
